import React, { useState, useEffect } from "react";
import { Image } from "semantic-ui-react";
import { Col, Row } from '../Grid';
import Wrapper from '../wrapper';
import HtmlCssJs from '../../assets/images/HTML-CSS-JS.png';
import jQuery from '../../assets/images/jquery.png';
import react from '../../assets/images/react.png';
import Mern from '../../assets/images/mern.png';
import SQL from '../../assets/images/mysql.png';
import Node from '../../assets/images/nodejs-logo.png';
import Git from '../../assets/images/git.jpg';
import Heroku from '../../assets/images/heroku.jpg';
import Mongo from '../../assets/images/mongodb.png';
import './style.css';


function Skills() {
	const [offSetX, setOffSetX] = useState(0);
	const handleScroll = () => setOffSetX(window.pageXOffset);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);

		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div className='technologies'>
			<h2 textAlign='center'
				className="tech-title">Technologies</h2>
			<div className="tech-list">
				<Image className="html-image" src={HtmlCssJs} display="flex" />
				<Image className="tech-images" src={jQuery} display="flex" />
				<Image className="mern-image" src={Mern} display="flex" />
				<Image className="tech-images" src={SQL} display="flex" />
				<Image className="tech-images" src={Mongo} circular display="flex" />
				<Image className="tech-images" src={Git} circular display="flex" />
				<Image className="tech-images" src={Heroku} circular display="flex" />
				
				
			</div>
		</div>
	);
}

export default Skills;